export enum NewsStatusEnum {
  DRAFT = 'DRAFT',
  READY = 'READY',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
}
